import { render } from "./Game.vue?vue&type=template&id=8ae51be6"
const script = {}

import "./Game.vue?vue&type=style&index=0&id=8ae51be6&scss=true&lang=css"

import exportComponent from "D:\\Project\\skin-web\\龙珠宇宙\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__